import type { CaseHistoryPortalConfig } from "@/types/task-actions";

/** Matches PryzmWebApi `PatientPortalService.PortalSessionLockedMessage`. */
export const PORTAL_SESSION_LOCKED_MESSAGE =
  "This visit's record has been signed and can no longer be changed.";

export const PORTAL_SESSION_LOCKED_PATIENT_MESSAGE =
  "Your visit record has been finalized and can no longer be changed.";

export function isPortalConfigRecordLocked(record: unknown): boolean {
  if (record == null || typeof record !== "object") return false;
  const o = record as Record<string, unknown>;
  return o.locked === true || o.Locked === true;
}

export function isPortalHistorySessionLocked(configs: CaseHistoryPortalConfig[] | null | undefined): boolean {
  if (!configs?.length) return false;
  return configs.some((c) => isPortalConfigRecordLocked(c));
}

export function lockedMessageFromApiBody(body: unknown): string {
  if (body == null || typeof body !== "object") return PORTAL_SESSION_LOCKED_PATIENT_MESSAGE;
  const o = body as Record<string, unknown>;
  const err = o.error ?? o.Error ?? o.reason ?? o.Reason;
  if (typeof err === "string" && err.trim()) return err.trim();
  return PORTAL_SESSION_LOCKED_PATIENT_MESSAGE;
}

export function isApiLockedResponse(error: unknown): boolean {
  if (error == null || typeof error !== "object") return false;
  const response = (error as { response?: { status?: number; data?: unknown } }).response;
  if (response?.status === 409) return true;
  const data = response?.data;
  if (data != null && typeof data === "object") {
    const o = data as Record<string, unknown>;
    return o.locked === true || o.Locked === true;
  }
  return false;
}

export function portalLockedMessageFromError(error: unknown): string {
  if (error != null && typeof error === "object") {
    const response = (error as { response?: { data?: unknown } }).response;
    if (response?.data != null) return lockedMessageFromApiBody(response.data);
  }
  return PORTAL_SESSION_LOCKED_PATIENT_MESSAGE;
}
